import storejs from 'store';
import router from '../../router';

const ERROR_MESSAGES = {
  UNAUTHORIZED: 'Usuário ou senha inválidos!',
  CONNECTION_ERROR:
    'Ops... Sem conexão! Tente novamente em alguns instantes :)',
  UNKNOWN_ERROR:
    'Ops... Tivemos um problema no servidor. Por favor, tente novamente em alguns instantes :)',
  OPENID_DISABLED: 'OpenID desabilitado',
};

const getters = {
  isLoading: state => state.isLoading,
  snackbar: state => state.snackbar,
  isLoggedIn: state => state.isLoggedIn,
  isAdminUser: state => state.isAdminUser,
};

const state = {
  currentUser: storejs.get('currentUser', null),
  isLoggedIn: !!storejs.get('token'),
  isAdminUser: false,
  isLoading: false,
  snackbar: false,
  errorMessage: null,
  initialUrl: storejs.get('initalUrl', null),
};

const actions = {
  loginCatraca(
    { commit, dispatch, rootState: { pautaClient } },
    { username, password },
  ) {
    commit('SHOW_LOADING', true);
    pautaClient
      .loginCatraca({ username, password })
      .then(response => {
        commit('SET_CREDENTIALS', {
          token: response.token,
          userData: { ...response },
        });

        dispatch('analyticsUpdateUserId', response.userData);
        dispatch('analyticsLogin');

        dispatch('checkIfAdmin');

        if (state.initialURL) {
          router.push(state.initialURL);
          storejs.remove('initialUrl');
        } else {
          router.push('/');
        }
      })
      .catch(error => {
        if (!error.response) {
          error.response = { status: 500 };
        } else if (error.code === 'ECONNABORTED') {
          // Handling in case axios request times out. In this case, it will not
          // give an error.response with a status code (error.response.status),
          // instead, it will give an error.code with the value 'ECONNABORTED'.
          error.response = { status: 504 };
        }
        switch (error.response.status) {
          case 401:
            commit('SET_ERROR_MESSAGE', ERROR_MESSAGES.UNAUTHORIZED);
            break;
          case 500:
            commit('SET_ERROR_MESSAGE', ERROR_MESSAGES.UNKNOWN_ERROR);
            break;
          default:
            commit('SET_ERROR_MESSAGE', error);
            break;
        }
        commit('SHOW_SNACKBAR', true);
      })
      .then(() => {
        commit('SHOW_LOADING', false);
      });
  },
  checkIfAdmin({ commit, rootState }) {
    const token = state.currentUser.token;
    rootState.adminClient
      .isUserAdmin(token)
      .then(() => {
        commit('SET_IS_ADMIN_USER', true);
      })
      .catch(() => {
        commit('SET_IS_ADMIN_USER', false);
      });
  },
  loginOID() {
    const clientId = process.env.VUE_APP_CLIENT_ID;
    const redirectUri = encodeURIComponent(process.env.VUE_APP_REDIRECT_URL);
    let url = process.env.VUE_APP_LOGIN_URL;
    url = url
      .replace('{%CLIENT_ID%}', clientId)
      .replace('{%REDIRECT_URI%}', redirectUri);
    location.replace(url);
  },
  getUserToken(
    { dispatch, commit, rootState: { pautaClient, adminClient } },
    code,
  ) {
    pautaClient
      .loginOID(code)
      .then(response => {
        commit('SET_CREDENTIALS', {
          token: response.token,
          userData: { ...response },
        });
        dispatch('updateUserId', response.userData);
        dispatch('analyticsLogin');

        adminClient
          .isUserAdmin(response.token)
          .then(() => {
            commit('SET_IS_ADMIN_USER', true);
          })
          .catch(() => {
            commit('SET_IS_ADMIN_USER', false);
          });
        if (state.initialUrl) {
          router.push(state.initialUrl);
          storejs.remove('initialUrl');
        } else {
          router.push('/');
        }
      })
      .catch(error => {
        switch (error.response.status) {
          case 404:
            commit('SET_ERROR_MESSAGE', ERROR_MESSAGES.OPENID_DISABLED);
            break;
          default:
            commit('SET_ERROR_MESSAGE', ERROR_MESSAGES.UNKNOWN_ERROR);
            break;
        }
        commit('SHOW_SNACKBAR', true);
        router.replace('/login');
      });
  },
  logout({ commit }) {
    commit('CLEAR_CREDENTIALS');
    router.push('/login');
  },
  updateSnack({ commit }, { show, message }) {
    commit('UPDATE_SNACKBAR', { show, message });
  },
  setInitialUrl({ commit }, value) {
    commit('SET_INITIAL_URL', value.split('#')[1]);
  },
  showSnackbarWithMessage({ commit }, message) {
    commit('SET_ERROR_MESSAGE', message);
    commit('SHOW_SNACKBAR', true);
  },

  async forcePermissionsRefresh({ rootState, dispatch }) {
    try {
      Promise.allSettled([
        rootState.pautaClient.refreshFolders(rootState.user.currentUser.token),
        rootState.pautaClient.refreshUserProfiles(
          rootState.user.currentUser.token,
        ),
      ]);

      dispatch(
        'news/updateFeedbackMessage',
        'Permissões atualizadas com sucesso.',
      );
    } catch (err) {
      dispatch(
        'news/updateFeedbackMessage',
        'Ocorreu um erro na atualização das permissões. Por favor tente novamente em alguns minutos.',
      );
    } finally {
      dispatch('news/snackbarTrigger', true);
    }
  },
};

const mutations = {
  SHOW_LOADING(state, value) {
    state.isLoading = value;
  },
  SHOW_SNACKBAR(state, value) {
    state.snackbar = value;
  },
  SET_CREDENTIALS(state, { token, userData }) {
    storejs.set('token', token);
    storejs.set('currentUser', userData);
    state.isLoggedIn = true;
    state.currentUser = userData;
  },
  SET_IS_ADMIN_USER(state, value) {
    state.isAdminUser = value;
  },
  CLEAR_CREDENTIALS(state) {
    storejs.remove('token');
    storejs.remove('currentUser');
    state.currentUser = null;
    state.isLoggedIn = false;
  },
  SET_ERROR_MESSAGE(state, message) {
    state.errorMessage = message;
  },
  SET_INITIAL_URL(state, value) {
    storejs.set('initialUrl', value);
  },
};

export default {
  getters,
  state,
  actions,
  mutations,
};
